import { render, staticRenderFns } from "./organization-role-selector.vue?vue&type=template&id=529984b1"
import script from "./organization-role-selector.vue?vue&type=script&lang=js"
export * from "./organization-role-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports